import { render } from "./DefaultTimeValueForStartDateAndEndDate.vue?vue&type=template&id=655c2408"
import script from "./DefaultTimeValueForStartDateAndEndDate.vue?vue&type=script&lang=ts"
export * from "./DefaultTimeValueForStartDateAndEndDate.vue?vue&type=script&lang=ts"
script.render = render

export default script